export default __webpack_public_path__ + "static/media/personality-share.237dea94.svg";